<template>
  <VCard>
    <template #title>
      Let's Debug Login
      <VBtn
        size="small"
        color="primary"
        text="Update LetsDebugLoginData"
        @click="updateLetsDebugLoginData"
      />
      <VCheckbox
        v-model="closeDialogAfterLogin"
        label="Close Dialog after login"
        @click="closeDialogAfterLogin = !closeDialogAfterLogin"
      />
    </template>
    <template #text>
      <div class="login-grid">
        <div
          v-for="(item, index) in LoginPreset"
          :key="index"
          class="login-grid-item"
          @click="login(item)"
        >
          {{ item.title }}
        </div>
      </div>
    </template>
  </VCard>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      closeDialogAfterLogin: true,
    };
  },
  computed: {
    LoginPreset() {
      return [
        { title: "560 Admin", user_type_code: 560 },
        { title: "550 センター長", user_type_code: 550 },
        { title: "540 事務スタッフ", user_type_code: 540 },
        { title: "530 担当者", user_type_code: 530 },
        { title: "520 営業", user_type_code: 520 },
        { title: "410 教室(オンライン教室)", user_type_code: 410 },
        { title: "420 教室（直営）", user_type_code: 420 },
        { title: "430 教室（FC）", user_type_code: 430 },
        { title: "300 Teacher", user_type_code: 300 },
        { title: "110 Student", user_type_code: 110 },
        { title: "120 Student", user_type_code: 120 },
        { title: "130 Student", user_type_code: 130 },
        ...this.LetsDebugLoginData,
      ];
    },
    LetsDebugLoginData: {
      get() {
        const data = localStorage.getItem("LetsDebugLoginData") || "[]";
        return JSON.parse(data);
      },
      set(val) {
        localStorage.setItem("LetsDebugLoginData", JSON.stringify(val));
      },
    },
  },
  methods: {
    ...mapActions("Auth", ["Auth_login"]),
    async login(item) {
      await this.Auth_login(item);
      this.$router.push({ name: "Home" });
      if (this.closeDialogAfterLogin) this.$emit("closeDialog");
    },
    async updateLetsDebugLoginData() {
      const result = prompt(
        "Enter new data in JSON format",
        JSON.stringify(this.LetsDebugLoginData, null, 2)
      );
      if (result) {
        try {
          this.LetsDebugLoginData = JSON.parse(result);
          this.$dialog.notify.success(
            "Reload the page to show the updated data"
          );
        } catch (e) {
          this.$dialog.notify.error("Invalid JSON format");
        }
      }
    },
  },
};
</script>

<style scoped>
.login-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
}
.login-grid-item {
  cursor: pointer;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.login-grid-item:hover {
  background-color: #f0f0f0;
}
</style>
